import _ from 'lodash'
import { FETCH_CARRIER_IDS, FETCH_CARRIER_ID } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CARRIER_IDS:
      return action.payload
    case FETCH_CARRIER_ID:
      return _.unionBy([action.payload], state, 'carrier_id')
    default:
      return state
  }
}
